import { ChevronLeftCircle, ChevronRightCircle } from 'lucide-react';
import React from 'react';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import { useIntl } from 'react-intl';
function Arrow({
  children,
  disabled,
  onClick,
  label,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
  label: string;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        right: '1%',
        opacity: disabled ? '0' : '1',
        userSelect: 'none',
      }}
    >
      {children}
    </button>
  );
}

export function LeftArrow() {
  const intl = useIntl();
  const { isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isFirstItemVisible,
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow
      disabled={disabled}
      onClick={() => scrollPrev()}
      label={intl.formatMessage({
        defaultMessage: 'Scroll to previous items',
        description:
          'Accessible name for the previous items arrow in a horizontal career-site carousel',
      })}
    >
      <ChevronLeftCircle className="absolute left-1 stroke-gray-500 z-10 fill-white w-8 h-8 stroke-1" />
    </Arrow>
  );
}

export function RightArrow() {
  const intl = useIntl();
  const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isLastItemVisible,
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow
      disabled={disabled}
      onClick={() => scrollNext()}
      label={intl.formatMessage({
        defaultMessage: 'Scroll to next items',
        description:
          'Accessible name for the next items arrow in a horizontal career-site carousel',
      })}
    >
      <ChevronRightCircle className="absolute right-1 stroke-gray-500 z-10 fill-white w-8 h-8 stroke-1" />
    </Arrow>
  );
}
